import React from 'react';
import { Reveal } from './Reveal';
import { CountdownBlock } from './CountdownBlock';
import { PricingCards } from './PricingCards';
import type { CountdownParts } from '../hooks/useCountdown';
type FinalCTASectionProps = {
  parts: CountdownParts;
};
export function FinalCTASection({
  parts
}: FinalCTASectionProps) {
  return <section id="cierre" aria-label="Última oportunidad" className="w-full bg-cream-200 py-16 sm:py-24" data-id="element-65" data-mp="uk1y6lfhkze">
      <div className="mx-auto max-w-4xl px-5 sm:px-8" data-id="element-66" data-mp="2zf1zts18d53f">
        <Reveal data-id="element-67" data-mp="34c26o55wmbvl">
          <div className="text-center" data-id="element-68" data-mp="34bsce5dttik3">
            <p className="text-xs font-bold uppercase tracking-[0.18em] text-terracotta-600 sm:text-sm" data-id="element-69" data-mp="34ahbcdbrmowo">
              ⏰ Precio de lanzamiento — cierra en:
            </p>
            <CountdownBlock parts={parts} data-id="element-70" data-mp="3e36jozc0rmns" />
          </div>
        </Reveal>

        <div className="mt-12" data-id="element-71" data-mp="2gnspjgjmycas">
          <PricingCards data-id="element-72" data-mp="2gmhldfma32j5" />
        </div>

        <Reveal delay={0.08} data-id="element-73" data-mp="2lm3yzq60qksh">
          <div className="mt-10 text-center" data-id="element-74" data-mp="2llas8p727vac">
            <p className="text-sm font-medium text-bark-600 sm:text-base" data-id="element-75" data-mp="2ljzkyfeeo5eh">
              🔒 Pago 100% seguro · ⚡ Acceso en 5 minutos · 🛡️ Garantía 7 días
            </p>
            <p className="mt-3 text-xs font-medium text-bark-400 sm:text-sm" data-id="element-76" data-mp="21x905me6ebp3">
              💳 Mercado Pago | Tarjeta | Transferencia
            </p>
          </div>
        </Reveal>
      </div>
    </section>;
}